import axios from "axios";
import API_URL from "../config/apiConfig";

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const supportErrorMessage = (error, fallback = "خطایی رخ داد. دوباره تلاش کنید.") =>
  error?.response?.data?.error?.message || error?.response?.data?.message || fallback;

export const TICKET_CATEGORIES = [
  { value: "technical", label: "مشکل فنی" },
  { value: "usage", label: "سؤال درباره استفاده" },
  { value: "billing", label: "اشتراک و پرداخت" },
  { value: "feature_request", label: "پیشنهاد قابلیت جدید" },
  { value: "other", label: "سایر" },
];

export const TICKET_STATUS_LABELS = {
  open: { label: "در انتظار بررسی", className: "bg-amber-50 text-amber-700" },
  in_progress: { label: "در حال بررسی", className: "bg-blue-50 text-blue-700" },
  waiting_restaurant: { label: "پاسخ داده شد", className: "bg-secondary_1 text-secondary" },
  resolved: { label: "بسته شد", className: "bg-gray-100 text-gray-500" },
};

export const categoryLabel = (value) => TICKET_CATEGORIES.find((c) => c.value === value)?.label || "سایر";

export const getMyTickets = () =>
  axios.get(`${API_URL}/api/support/tickets`, { headers: headers() }).then(({ data }) => data.tickets);

export const getUnreadTicketCount = () =>
  axios.get(`${API_URL}/api/support/tickets/unread-count`, { headers: headers() }).then(({ data }) => data.unread);

export const createTicket = (payload) =>
  axios.post(`${API_URL}/api/support/tickets`, payload, { headers: headers() }).then(({ data }) => data.ticket);

export const getMyTicket = (ticketId) =>
  axios.get(`${API_URL}/api/support/tickets/${ticketId}`, { headers: headers() }).then(({ data }) => data);

export const replyToMyTicket = (ticketId, body) =>
  axios.post(`${API_URL}/api/support/tickets/${ticketId}/messages`, { body }, { headers: headers() }).then(({ data }) => data);

export const resolveMyTicket = (ticketId) =>
  axios.post(`${API_URL}/api/support/tickets/${ticketId}/resolve`, {}, { headers: headers() }).then(({ data }) => data.ticket);
